import type { App, Component } from 'vue'
import { Menu as VMenu } from 'floating-vue'

// WUK Components
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue'
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue'
import BaseInputWuk from '@ui-kit/components/inputs/BaseInput.vue'
import SwordPhoneWuk from '@ui-kit/components/inputs/SwordPhone.vue'
import SwordDropdownWuk from '@ui-kit/components/inputs/dropdowns/SwordDropdown.vue'
import SwordFormattedDateWuk from '@ui-kit/components/inputs/date/SwordFormattedDate.vue'
import SwordCheckboxWuk from '@ui-kit/components/inputs/checkboxes/SwordCheckbox.vue'
import SwordCheckboxGroupWuk from '@ui-kit/components/inputs/checkboxes/SwordCheckboxGroup.vue'
import InputErrorWuk from '@ui-kit/components/inputs/footnotes/InputError.vue'
import InputLabelWuk from '@ui-kit/components/inputs/labels/InputLabel.vue'
import MultipleInputEntriesWuk from '@ui-kit/components/inputs/MultipleInputEntries.vue'
import SwordRadioGroupWuk from '@ui-kit/components/inputs/radios/SwordRadioGroup.vue'
import SwordFileUploadWuk from '@ui-kit/components/inputs/SwordFileUpload.vue'
import SwordMeasureWuk from '@ui-kit/components/inputs/SwordMeasure.vue'
import SwordSearchWuk from '@ui-kit/components/inputs/SwordSearch.vue'
import SwordTextareaWuk from '@ui-kit/components/inputs/SwordTextarea.vue'
import SwordLinkWuk from '@ui-kit/components/links/SwordLink.vue'
import MenuWuk from '@ui-kit/components/menus/Menu.vue'
import SwordTabWuk from '@ui-kit/components/tab/SwordTab.vue'
import SwordTabGroupWuk from '@ui-kit/components/tab/SwordTabGroup.vue'

// Local/Bridge Components
import SwordPatientAttentionLevelWuk from '@/components/patient/PatientAttentionLevel.vue'
import SwordList from '@/components/menus/SwordList.vue'
import Pill from '@/components/micro/Pills/BasePill/index.vue'
import HoverToCopy from '@/components/common/HoverToCopy.vue'
import SwordTag from '@/components/common/SwordTag.vue' // Bridge component - Update import & drop proxy after Vue/UI upgrade
import SwordInput from '@/components/common/SwordInput.vue' // Bridge component - Vue 2 v-model to Vue 3 XInput
import SwordToggle from '@/components/common/SwordToggle.vue' // Bridge component - Vue 2 v-model to Vue 3 XToggle

// UI Components
import { XTooltip, XPopover, XAlert, XLoader, XAvatar, XDatepicker } from '@swordhealth/ui'

const wukComponents = {
  'SwordLoader': XLoader,
  'SwordIcon': SwordIconWuk,
  'SwordTextWuk': SwordInput,
  'SwordButtonWuk': SwordButtonWuk,
  'ProfilePicture': XAvatar,
  'SwordCheckboxWuk': SwordCheckboxWuk,
  'SwordTag': SwordTag,
  'SwordTooltip': XTooltip,
  'SwordPopoverWuk': XPopover,
  'HoverToCopy': HoverToCopy,
  'SwordDropdownWuk': SwordDropdownWuk,
  'SwordTextareaWuk': SwordTextareaWuk,
  'SwordToggle': SwordToggle,
  'SwordCheckboxGroupWuk': SwordCheckboxGroupWuk,
  'SwordPasswordWuk': SwordInput,
  'SwordRadioGroupWuk': SwordRadioGroupWuk,
  'SwordSearchWuk': SwordSearchWuk,
  'SwordPhoneWuk': SwordPhoneWuk,
  'InputLabelWuk': InputLabelWuk,
  'InputErrorWuk': InputErrorWuk,
  'SwordMeasureWuk': SwordMeasureWuk,
  'BaseInputWuk': BaseInputWuk,
  'SwordDate': XDatepicker,
  'SwordFormattedDateWuk': SwordFormattedDateWuk,
  'MultipleInputEntriesWuk': MultipleInputEntriesWuk,
  'SwordFileUploadWuk': SwordFileUploadWuk,
  'SwordAlertWuk': XAlert,
  'MenuWuk': MenuWuk,
  'BasePill': Pill,
  'SwordPatientAttentionLevelWuk': SwordPatientAttentionLevelWuk,
  'SwordLink': SwordLinkWuk,
  'SwordTabWuk': SwordTabWuk,
  'SwordTabGroupWuk': SwordTabGroupWuk,
  'SwordList': SwordList,
  'VMenu': VMenu,
}

export default {
  install(app: App) {
    Object.entries(wukComponents).forEach(([name, component]) => {
      app.component(name, component as Component)
    })
  },
}
